// window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
} catch (e) {}
import swal from 'sweetalert2';
window.Swal = swal;
import videojs from 'video.js';
window.videojs = videojs;
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// window.axios = require('axios');
//
// window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

// window.Pusher = require('./pusher.min');
// Pusher.logToConsole = false;
// window.pusher = new Pusher('3e38cdbf68b31fb52b3e', {cluster: 'ap2',forceTLS: false});
// window.pusher_chat = new Pusher('ad75c741295d91556cd7', {cluster: 'ap2',forceTLS: false});

// window.Pusher = require('./pusher.min');
// Pusher.logToConsole = false;
// window.pusher = new Pusher('3e38cdbf68b31fb52b3e', {cluster: 'ap2',forceTLS: false});
// window.pusher_chat = new Pusher('ad75c741295d91556cd7', {cluster: 'ap2',forceTLS: false});
